import { useMutation, useQueryClient } from '@tanstack/react-query';
import { suggestBusiness, SuggestBusinessRequest } from '@/api/endpoints/businesses';
import { BUSINESSES_QUERY_KEYS } from '@/api/queries/businesses';

/**
 * Hook for suggesting a new business
 *
 * Wraps the suggestBusiness API call in a React Query mutation.
 * On success, invalidates business queries so that the new pending
 * business appears in lists and search results.
 */
export function useSuggestBusiness() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SuggestBusinessRequest) => suggestBusiness(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: BUSINESSES_QUERY_KEYS.all });
    },
  });
}
